import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';
import humanizeString from '../../utils'
import { dateSorter } from '../../utils';
import { isBeforeToday } from '../../utils';
import LogoCell from '../../components/LogoCell/LogoCell.jsx';

import { useIsAdmin, useIsSuperAdmin, useMobileStore } from '../../store';
import { apiClient } from '../../api_actions/index';
import { Modal, Select, Space, Input } from 'antd';
import React, { useState, useEffect } from 'react';
//import './Notes.scss';

// Separate component. Previously, I had the useEffect within a Column, which violates the Rules of Hooks since it wasn't part of a React component
//  Moved this to its own function 
export default function LogosPage() {
  const isSuperAdmin = useIsSuperAdmin();
  const isMobile = useMobileStore((state) => state.isMobile);
  const [searchInput, setSearchInput] = useState('');
  const [customerLogoUrl, setCustomerLogoUrl] = useState(null);
  const { Search } = Input;
  
  const columns = [
    { 
        title: 'Name', 
        dataIndex: 'name', 
        key: 'name' 
    },
    {
      title: 'Logo',
      dataIndex: 'id',
      key: 'id',
      render: (id) => <LogoCell id={id} />  // Clean — no hooks in here
    },
  ];

  const formFields = [
    {
      name: 'id',
      label: 'Logo ID',
      type: 'textarea',
      placeholder: 'Logo ID',
      disabled: true,
    },
    {
      name: 'name',
      label: 'Name',
      type: 'textarea',  // This makes it a date picker
      placeholder: 'Name',
      rules: [{ required: true, message: 'Must Enter an internal name for the logo!' }]
    },
    {
      name: 'data',
      label: 'Data',
      type: 'upload', 
      rules: [{ required: true, message: 'Must upload a logo!' }]
    }
  ];

  return (
    <div className='container-wrapper'>
      <ModalEditTable
        createEndpoint="create/logos"
        editEndpoint="update/logos"
        readEndpoint="read/logos"
        deleteEndpoint="delete/logos"
        columns={columns}
        formFields={formFields}
        title="Logos"
      />
    </div>
  );
}